import { useRecoilValue } from "recoil";

import NumericInput from "src/common/components/numericInput";
import { isTerminal } from "src/common/helpers/productType";
import { BetTypeEnum } from "src/constants/enums/betType";
import { useTranslation } from "src/hooks/translation";
import { decimalString } from "src/constants/types";
import upperDataStore from "src/stores/upperData";
import { useBalance } from "src/hooks/balance";
import { useConfig } from "src/hooks/config";
import mainStore from "src/stores/main";

import "./style.scss";

interface IProps {
	value: decimalString;
	onChange(value: decimalString): void;
	className?: string;
	showMaxBetButton?: boolean;
	placeholder?: string;
	betType?: BetTypeEnum;
}

const StakeInput = ({ value, betType, onChange, className, placeholder, showMaxBetButton }: IProps) => {
	const t = useTranslation();
	const config = useConfig();
	const balance = useBalance();
	const { maxStake } = useRecoilValue(mainStore);
	const { currencyConfig } = useRecoilValue(upperDataStore);

	const setMaxStake = async () => {
		// onChange(isTerminal() ? `${Math.min(maxStake, balance)}` : `${maxStake}`);
		const newStake =
			(isTerminal()
				? betType === BetTypeEnum.System || config.useBalanceAsMaxStake
					? balance
					: Math.min(maxStake, balance)
				: maxStake) || 0;

		onChange(`${newStake}`); // show balance as max stake in terminal by now. because max stake logic for system type is not implemented
	};

	return (
		<div className={`B-stake-input-wrapper ${className || ""}`}>
			<NumericInput
				value={value}
				placeholder={placeholder || "Stake"}
				onChange={onChange}
				className={className}
				maxDecimalCount={currencyConfig?.rounding || 2}
				customButtons={config.staticStakes}
			/>

			<div className="B-stake-input-btns">
				{!!value && (
					<i className="B-stake-clear icon-circle-close" onClick={() => onChange("")} />
				)}

				{(config.enableMaxBetButton && showMaxBetButton) && (
					<button className="B-inp-max" onClick={setMaxStake}>
						{t("Max")}
					</button>
				)}
			</div>
		</div>
	);
};

export default StakeInput;
